export const drawings = [
  { title: "Officer", file: "/drawings/Officer.jpeg" },
  { title: "Coffee Date", file: "/drawings/Coffee Date.jpeg" },
  { title: "Backpack", file: "/drawings/Backpack.jpeg" },
  { title: "Scuba Steve", file: "/drawings/Scuba Steve.jpeg" },
  { title: "Grunt", file: "/drawings/Grunt.jpeg" },
  { title: "Treehouse", file: "/drawings/Treehouse.jpeg" },
  { title: "Binoculars", file: "/drawings/Binoculars.jpeg" },
  { title: "Enterprise", file: "/drawings/Enterprise.jpeg" },
  { title: "Genesis", file: "/drawings/Genesis.jpeg" },
  { title: "Bruce", file: "/drawings/Bruce.jpeg" },
  { title: "Ocean Giant", file: "/drawings/Ocean Giant.jpeg" },
  { title: "Kurt", file: "/drawings/Kurt.jpeg" },
  { title: "Journaling", file: "/drawings/Journaling.jpeg" },
  { title: "911", file: "/drawings/911.jpeg" },
  { title: "Ace Ventura", file: "/drawings/Ace Ventura.jpeg" },
  { title: "Crystal Lake", file: "/drawings/Crystal Lake.jpeg" },
  { title: "True Detective", file: "/drawings/True Detective.jpeg" },
  { title: "The Scarecrow", file: "/drawings/The Scarecrow.jpeg" },
  { title: "The Road", file: "/drawings/The Road.jpeg" },
  { title: "Dumbo's Mom", file: "/drawings/Dumbo's Mom.jpeg" },
  { title: "Navigator", file: "/drawings/Navigator.jpeg" },
  { title: "Cat & Fiddler", file: "/drawings/Cat & Fiddler.jpeg" },
  { title: "Taj Mahal", file: "/drawings/Taj Mahal.jpeg" },
];
